import { LogManager } from "@mcleod/core";
import { AutogenLayoutMobileCommGroupList } from "./autogen/AutogenLayoutMobileCommGroupList";
import { ActionButtonType, MobileCommGroupListToolPanel } from "./MobileCommGroupListToolPanel";

const log = LogManager.getLogger("lme.dispatch.mobilecomm.MobileCommUnitList");

export class MobileCommGroupList extends AutogenLayoutMobileCommGroupList {
    public _toolsPanel: MobileCommGroupListToolPanel;
    public isFindNearData: boolean = false;
    searchList: () => void;
    removeCircle: () => void;

    onLoad(): void | Promise<void> {
        this._toolsPanel = new MobileCommGroupListToolPanel(this, ActionButtonType.FILTER);
    }
}
